/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getHistoricalExchangeData} from '../api'

 export const useQueryGetHistoricalExchangeData = createReactQueryHook('getHistoricalExchangeData', getHistoricalExchangeData)
